import React from "react";
import {
  Container,
  Alert,
} from "reactstrap";
import { ListaSolicitudes } from "./ListaSolicitudes";
import { DatosSesion } from "../../../Components/Common/DatosSesion";

const ListView = () => {
  document.title = "Lista de Solicitudes | Farme";
  const perfil = DatosSesion("perfil");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <ListaSolicitudes perfil={perfil} />
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ListView;
